(function () {
  'use strict';

  var app = document.getElementById('gt-custom-order-app');
  if (!app) return;

  var NETLIFY = (app.dataset.netlify || '').replace(/\/$/, '');

  var form       = document.getElementById('gt-custom-order-form');
  var header     = app.querySelector('.gt-bulk__header');
  var successDiv = document.getElementById('gt-co-success');
  var msgEl      = document.getElementById('gt-co-msg');
  var submitBtn  = document.getElementById('gt-co-submit');
  var nameInput     = document.getElementById('gt-co-name');
  var emailInput    = document.getElementById('gt-co-email');
  var orgInput      = document.getElementById('gt-co-org');
  var uniInput      = document.getElementById('gt-co-university');
  var deadlineInput = document.getElementById('gt-co-deadline');
  var notesInput    = document.getElementById('gt-co-notes');

  // ── Combobox data ─────────────────────────────────────────
  var GREEK_ORGS = [
    'Alpha Chi Omega','Alpha Delta Pi','Alpha Epsilon Phi','Alpha Gamma Delta',
    'Alpha Omicron Pi','Alpha Phi','Alpha Sigma Alpha','Alpha Sigma Tau',
    'Alpha Xi Delta','Chi Omega','Delta Delta Delta','Delta Gamma','Delta Phi Epsilon',
    'Delta Zeta','Gamma Phi Beta','Kappa Alpha Theta','Kappa Delta','Kappa Kappa Gamma',
    'Phi Mu','Phi Sigma Sigma','Pi Beta Phi','Sigma Delta Tau','Sigma Gamma Rho',
    'Sigma Kappa','Sigma Lambda Gamma','Theta Phi Alpha','Zeta Phi Beta','Zeta Tau Alpha',
    'Alpha Epsilon Pi','Alpha Phi Alpha','Alpha Tau Omega','Beta Theta Pi',
    'Chi Phi','Chi Psi','Delta Chi','Delta Kappa Epsilon','Delta Sigma Phi',
    'Delta Tau Delta','Delta Upsilon','Kappa Alpha Order','Kappa Alpha Psi',
    'Kappa Sigma','Lambda Chi Alpha','Omega Psi Phi','Phi Beta Sigma',
    'Phi Delta Theta','Phi Gamma Delta','Phi Kappa Psi','Phi Kappa Sigma',
    'Phi Kappa Tau','Phi Sigma Kappa','Pi Kappa Alpha','Pi Kappa Phi',
    'Pi Lambda Phi','Sigma Alpha Epsilon','Sigma Alpha Mu','Sigma Chi',
    'Sigma Nu','Sigma Phi Epsilon','Sigma Pi','Tau Kappa Epsilon',
    'Theta Chi','Theta Delta Chi','Zeta Beta Tau','Zeta Psi'
  ];
  var UNIVERSITIES = [
    'Auburn University','Arizona State University','Boston College','Boston University',
    'Brigham Young University','Brown University','Carnegie Mellon University',
    'Clemson University','Colorado State University','Columbia University',
    'Cornell University','Dartmouth College','Duke University','Emory University',
    'Florida State University','Fordham University','George Washington University',
    'Georgetown University','Georgia Tech','Harvard University','Indiana University',
    'Iowa State University','James Madison University','Johns Hopkins University',
    'Louisiana State University','Loyola University','Marquette University',
    'Miami University','Michigan State University','New York University',
    'North Carolina State University','Northeastern University','Northwestern University',
    'Ohio State University','Oklahoma State University','Oregon State University',
    'Penn State University','Princeton University','Purdue University',
    'Rice University','Rutgers University','SMU','Syracuse University',
    'Temple University','Texas A&M University','Texas Tech University','Tulane University',
    'UC Berkeley','UC Davis','UC Irvine','UC Los Angeles','UC San Diego','UC Santa Barbara',
    'UNC Chapel Hill','University of Alabama','University of Arizona',
    'University of Arkansas','University of Colorado Boulder','University of Connecticut',
    'University of Delaware','University of Denver','University of Florida',
    'University of Georgia','University of Illinois','University of Iowa',
    'University of Kansas','University of Kentucky','University of Maryland',
    'University of Miami','University of Michigan','University of Minnesota',
    'University of Mississippi','University of Missouri','University of Nebraska',
    'University of Notre Dame','University of Oklahoma','University of Oregon',
    'University of Pennsylvania','University of Pittsburgh','University of Richmond',
    'University of South Carolina','University of Southern California',
    'University of Tennessee','University of Texas at Austin','University of Utah',
    'University of Vermont','University of Virginia','University of Washington',
    'University of Wisconsin','Vanderbilt University','Villanova University',
    'Virginia Tech','Wake Forest University','Washington University in St. Louis',
    'William & Mary','Yale University'
  ];

  function makeCombo(inputEl, dropEl, items) {
    if (!inputEl || !dropEl) return;
    function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
    function highlight(text, q) {
      if (!q) return document.createTextNode(text);
      var re = new RegExp('(' + escapeRe(q) + ')', 'gi');
      var frag = document.createDocumentFragment();
      text.split(re).forEach(function (p) {
        if (re.test(p)) { var m = document.createElement('mark'); m.textContent = p; frag.appendChild(m); }
        else frag.appendChild(document.createTextNode(p));
      });
      return frag;
    }
    function openList(query) {
      var q = (query || '').trim().toLowerCase();
      var matches = q ? items.filter(function (i) { return i.toLowerCase().includes(q); }) : items;
      if (!matches.length) { closeList(); return; }
      dropEl.innerHTML = '';
      matches.slice(0, 40).forEach(function (item) {
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.appendChild(highlight(item, q));
        li.addEventListener('mousedown', function (e) { e.preventDefault(); inputEl.value = item; closeList(); });
        dropEl.appendChild(li);
      });
      dropEl.hidden = false;
      inputEl.setAttribute('aria-expanded', 'true');
    }
    function closeList() { dropEl.hidden = true; inputEl.setAttribute('aria-expanded', 'false'); }
    inputEl.addEventListener('input', function () { openList(inputEl.value); });
    inputEl.addEventListener('focus', function () { openList(inputEl.value); });
    inputEl.addEventListener('blur', function () { setTimeout(closeList, 150); });
    inputEl.addEventListener('keydown', function (e) {
      if (dropEl.hidden) return;
      var lis = dropEl.querySelectorAll('li');
      var active = dropEl.querySelector('li[aria-selected="true"]');
      var idx = active ? Array.from(lis).indexOf(active) : -1;
      if (e.key === 'ArrowDown') { e.preventDefault(); if (active) active.removeAttribute('aria-selected'); var next = lis[Math.min(idx+1,lis.length-1)]; next.setAttribute('aria-selected','true'); next.scrollIntoView({block:'nearest'}); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (active) active.removeAttribute('aria-selected'); var prev = lis[Math.max(idx-1,0)]; prev.setAttribute('aria-selected','true'); prev.scrollIntoView({block:'nearest'}); }
      else if (e.key === 'Enter' && active) { e.preventDefault(); inputEl.value = active.textContent; closeList(); }
      else if (e.key === 'Escape') { closeList(); }
    });
  }

  makeCombo(orgInput, document.getElementById('gt-co-org-dropdown'), GREEK_ORGS);
  makeCombo(uniInput, document.getElementById('gt-co-uni-dropdown'), UNIVERSITIES);
  (function () {
    var p = new URLSearchParams(window.location.search);
    var org = p.get('org') || p.get('organization');
    var uni = p.get('university') || p.get('uni');
    if (org && orgInput) orgInput.value = org;
    if (uni && uniInput) uniInput.value = uni;
  })();

  // ── Garment Data ──────────────────────────────────────────

  var GARMENT_TYPES = [
    { id: 'hoodie',     label: 'Hoodie' },
    { id: 'mockneck',   label: 'Mockneck' },
    { id: 'tee',        label: 'Tee' },
    { id: 'sweatpants', label: 'Sweatpants' },
    { id: 'shorts',     label: 'Shorts' }
  ];

  // Color → blank product image URL (from blanks collections)
  var GARMENT_IMAGES = {
    hoodie: {
      'Black':        'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Black-front-v2.png?v=1784773023',
      'Brown':        'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Brown-front-v2.png?v=1784773028',
      'Gray':         'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Gray-front-v2.png?v=1784773051',
      'Plum Purple':  'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Plum_Purple-front-v2.png?v=1784773105',
      'Eden Green':   'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Eden_Green-front-v2.png?v=1784773044',
      'Apricot':      'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Apricot-front-v2.png?v=1784773019',
      'Navy Blue':    'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Navy_Blue-front-v2.png?v=1784773093',
      'Coffee':       'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Coffee-front-v2.png?v=1784773032',
      'Medium Green': 'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Medium_Green-front-v2.png?v=1784773089',
      'Gray Blue':    'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Gray_Blue-front-v2.png?v=1784773061',
      'Klein Blue':   'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Klein_Blue-front-v2.png?v=1784773074',
      'Dark Brown':   'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Dark_Brown-front-v2.png?v=1784773036',
      'Gray Coffee':  'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Gray_Coffee-front-v2.png?v=1784773065',
      'Red':          'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Red-front-v2.png?v=1784773108',
      'Light Blue':   'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Light_Blue-front-v2.png?v=1784773077',
      'Oat Gray':     'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Oat_Gray-front-v2.png?v=1784773097',
      'Pink':         'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Pink-front-v2.png?v=1784773101',
      'Medium Blue':  'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Medium_Blue-front-v2.png?v=1784773085',
      'White':        'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/White-front-v2.png?v=1784773112',
      'Jeans Blue':   'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/Jeans_Blue-front-v2.png?v=1784773070'
    },
    mockneck: {
      'Pink':         'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/686951cdda4e43f6b920172867dfa6a0.png?v=1784774043',
      'White':        'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/fd5303a61dfc42d29b317583fc6d444b.png?v=1784774043',
      'Yellow':       'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/eb2d62d715ef430699384560e2be700c.png?v=1784774043',
      'Flower Gray':  'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/0890cda4614240549c34fe699329aeaf.png?v=1784774043',
      'Black':        'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/a93f22ee4b0c4fd98b0def034cdf4816.png?v=1784774043',
      'Cream Apricot':'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/58be5ad89ff544daa61a272ee47e2457.png?v=1784774043'
    },
    sweatpants: {
      'Black':        'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/bc21a1a1d5e545c98b1473095d0183a5.png?v=1784764848',
      'Gray':         'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/02b49e09ac2f49828a9cf7620b1e7d88.png?v=1784764848',
      'Medium Blue':  'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/5b6bdbab8e5a440cbe5142792384b902.png?v=1784764848',
      'Flower Gray':  'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/be2f2de5a8264d5c9ea503b2547cf7a6.png?v=1784764848',
      'Eden Green':   'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/bde36b0e7f3c4b82bceb30c2e3fa90cd.png?v=1784764848',
      'Navy Blue':    'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/4925ff078b2c4e38a5d1435bb02b2c05.png?v=1784764848',
      'Dark Gray':    'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/4c2987b53e21465d9bc11df0c817c49e.png?v=1784764848',
      'Gray Apricot': 'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/67655ba555d64b5abfa75829ba7fcaf0.png?v=1784764848',
      'Gray Coffee':  'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/6f66a04d79eb41f29fed9d1698570a8b.png?v=1784764848'
    },
    tee: {
      'Wine Red':   'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/b0d0dbdf0c0e4f348036c96af668fa13.png?v=1786289554',
      'Pink':       'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/4bc059e5980c4a5db70a48265d15a0c5.png?v=1786289553',
      'White':      'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/d3ec005c654f45529fbfa35642aaf33c.png?v=1786289553',
      'Blue':       'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/4084ee56c19b455f84560c0cf388c686.png?v=1786289553',
      'White Gray': 'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/eab26be5915d422ca1835a897b9e0854.png?v=1786289553',
      'Apricot':    'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/5be8232f702346ee880010fe4888cd88.png?v=1786289554',
      'Black':      'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/6bc5f26782ae4d1bbd69bdd61496e1eb.png?v=1786289553',
      'Navy Blue':  'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/b76bb866bfb540a689093422d82e33e9.png?v=1786289553',
      'Coffee':     'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/7c17b031d736460592e87590e7537f4a.png?v=1786289554',
      'Dark Gray':  'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/d17d5184221045bcafa8039819a944fd.png?v=1786289553'
    },
    shorts: {
      'Pink':          'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/22af89a452fa40fd910ca9a147067e89.png?v=1786136359',
      'White':         'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/9af6dc953db24ad58c3e6509ce013bf2.png?v=1786136358',
      'Yellow':        'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/6af0c51445df4813ba4251eec530fa3e.png?v=1786136358',
      'Flower Gray':   'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/f267e5fa8e6846ccb6d5219a80d5e471.png?v=1786136358',
      'Black':         'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/4acf0e7972bc4cf58be5ab2cb2be3991.png?v=1786136358',
      'Cream Apricot': 'https://cdn.shopify.com/s/files/1/0803/1469/5929/files/986d77bdfa8f41ff912a1629808d6e3e.png?v=1786136358'
    }
  };

  // Hex values for garment color swatches
  var COLOR_HEX = {
    'White': '#F5F5F5', 'Black': '#1C1C1C', 'Gray': '#ADADAD', 'Light Gray': '#C8C8C8',
    'Dark Gray': '#4F4F4F', 'Oat Gray': '#C4BFB0', 'Flower Gray': '#B8B0AA',
    'Navy': '#1D3461', 'Navy Blue': '#163263', 'Blue': '#3B6FB6', 'Medium Blue': '#5B8EC8',
    'Light Blue': '#87CEEB', 'Gray Blue': '#7A9DB5', 'Jeans Blue': '#3D6B8C', 'Klein Blue': '#002FA7',
    'Wine Red': '#722F37', 'White Gray': '#DEDAD5',
    'Red': '#C0392B', 'Pink': '#F4A7B9', 'Purple': '#6C3483', 'Dark Purple': '#4A1E6B',
    'Plum Purple': '#6B2D6B', 'Green': '#27623C', 'Medium Green': '#3A8050', 'Eden Green': '#3D6B4F',
    'Brown': '#7B4F2E', 'Dark Brown': '#4A2E18', 'Coffee': '#6F4E37', 'Gray Coffee': '#9B7D6F',
    'Gray Apricot': '#C9A99B', 'Cream Apricot': '#F2D9C4', 'Apricot': '#FBCBA5', 'Yellow': '#F5D76E',
    // Text colors
    'Gold': '#D4AF37', 'Silver': '#C0C0C0', 'Maroon': '#6D2B3D', 'Forest Green': '#27623C',
    'Orange': '#E67E22'
  };

  function getGarmentColors(type) {
    var imgs = GARMENT_IMAGES[type];
    if (!imgs) {
      // No specific blanks yet — show common set
      return ['White','Black','Gray','Navy Blue','Red','Pink','Purple','Green','Brown','Yellow'].map(function(n) {
        return { name: n, hex: COLOR_HEX[n] || '#999' };
      });
    }
    return Object.keys(imgs).map(function (name) {
      return { name: name, hex: COLOR_HEX[name] || '#999' };
    });
  }

  function getMatchingColors(type1, type2) {
    var imgs1 = GARMENT_IMAGES[type1];
    var imgs2 = GARMENT_IMAGES[type2];
    if (!imgs1 || !imgs2) {
      return getGarmentColors(type2);
    }
    var intersect = Object.keys(imgs1).filter(function (n) { return imgs2[n]; });
    return intersect.map(function (name) { return { name: name, hex: COLOR_HEX[name] || '#999' }; });
  }

  function getPreviewUrl(type, colorName) {
    var imgs = GARMENT_IMAGES[type];
    if (!imgs) return null;
    if (colorName && imgs[colorName]) return imgs[colorName];
    return Object.values(imgs)[0] || null;
  }

  var TEXT_COLORS = [
    { name: 'White',        hex: '#FFFFFF' },
    { name: 'Black',        hex: '#000000' },
    { name: 'Gold',         hex: '#D4AF37' },
    { name: 'Silver',       hex: '#C0C0C0' },
    { name: 'Navy',         hex: '#1D3461' },
    { name: 'Red',          hex: '#C0392B' },
    { name: 'Maroon',       hex: '#6D2B3D' },
    { name: 'Pink',         hex: '#F4A7B9' },
    { name: 'Purple',       hex: '#6C3483' },
    { name: 'Forest Green', hex: '#27623C' },
    { name: 'Light Blue',   hex: '#87CEEB' },
    { name: 'Orange',       hex: '#E67E22' }
  ];

  var DESIGN_TYPES = [
    { id: 'greek',    label: 'Greek Letters' },
    { id: 'shortform',label: 'Short Form' },
    { id: 'fullform', label: 'Full Form' },
    { id: 'custom',   label: 'Custom Text' }
  ];

  var PRINT_SIDES = [
    { id: 'front',      label: 'Front only' },
    { id: 'back',       label: 'Back only' },
    { id: 'front-back', label: 'Front & Back' }
  ];
  var FRONT_PLACEMENTS = [
    { id: 'across-front',         label: 'Across Front' },
    { id: 'left-chest',           label: 'Left Chest' },
    { id: 'right-chest',          label: 'Right Chest' },
    { id: 'vertical-chest-left',  label: 'Vertical Chest Left' },
    { id: 'vertical-chest-right', label: 'Vertical Chest Right' }
  ];
  var BACK_PLACEMENTS = [
    { id: 'full-back',   label: 'Full Back' },
    { id: 'across-back', label: 'Across Back' }
  ];
  var BOTTOM_FRONT_PLACEMENTS = [
    { id: 'front-right-leg-horizontal', label: 'Front Right Leg — Horizontal' },
    { id: 'front-left-leg-horizontal',  label: 'Front Left Leg — Horizontal' },
    { id: 'front-right-leg-vertical',   label: 'Front Right Leg — Vertical' },
    { id: 'front-left-leg-vertical',    label: 'Front Left Leg — Vertical' }
  ];
  var BOTTOM_BACK_PLACEMENTS = [
    { id: 'back-right-leg-horizontal', label: 'Back Right Leg — Horizontal' },
    { id: 'back-left-leg-horizontal',  label: 'Back Left Leg — Horizontal' },
    { id: 'back-right-leg-vertical',   label: 'Back Right Leg — Vertical' },
    { id: 'back-left-leg-vertical',    label: 'Back Left Leg — Vertical' }
  ];
  var BOTTOM_GARMENTS = { sweatpants: true, shorts: true };

  var FONTS = [
    { name: 'Bebas Neue',         family: "'Bebas Neue', sans-serif",        weight: '400', cat: 'Display' },
    { name: 'Anton',              family: "'Anton', sans-serif",             weight: '400', cat: 'Display' },
    { name: 'Oswald',             family: "'Oswald', sans-serif",            weight: '600', cat: 'Display' },
    { name: 'Teko',               family: "'Teko', sans-serif",              weight: '600', cat: 'Display' },
    { name: 'Fjalla One',         family: "'Fjalla One', sans-serif",        weight: '400', cat: 'Display' },
    { name: 'Righteous',          family: "'Righteous', cursive",            weight: '400', cat: 'Display' },
    { name: 'Russo One',          family: "'Russo One', sans-serif",         weight: '400', cat: 'Display' },
    { name: 'Abril Fatface',      family: "'Abril Fatface', cursive",        weight: '400', cat: 'Display' },
    { name: 'Bangers',            family: "'Bangers', cursive",              weight: '400', cat: 'Display' },
    { name: 'Boogaloo',           family: "'Boogaloo', cursive",             weight: '400', cat: 'Display' },
    { name: 'Fredoka One',        family: "'Fredoka One', cursive",          weight: '400', cat: 'Display' },
    { name: 'Lilita One',         family: "'Lilita One', cursive",           weight: '400', cat: 'Display' },
    { name: 'Titan One',          family: "'Titan One', cursive",            weight: '400', cat: 'Display' },
    { name: 'Ultra',              family: "'Ultra', serif",                  weight: '400', cat: 'Display' },
    { name: 'Squada One',         family: "'Squada One', cursive",           weight: '400', cat: 'Display' },
    { name: 'Passion One',        family: "'Passion One', cursive",          weight: '900', cat: 'Display' },
    { name: 'Permanent Marker',   family: "'Permanent Marker', cursive",     weight: '400', cat: 'Display' },
    { name: 'Archivo Black',      family: "'Archivo Black', sans-serif",     weight: '400', cat: 'Display' },
    { name: 'Black Han Sans',     family: "'Black Han Sans', sans-serif",    weight: '400', cat: 'Display' },
    { name: 'Montserrat',         family: "'Montserrat', sans-serif",        weight: '700', cat: 'Sans Serif' },
    { name: 'Raleway',            family: "'Raleway', sans-serif",           weight: '700', cat: 'Sans Serif' },
    { name: 'Josefin Sans',       family: "'Josefin Sans', sans-serif",      weight: '700', cat: 'Sans Serif' },
    { name: 'Ubuntu',             family: "'Ubuntu', sans-serif",            weight: '700', cat: 'Sans Serif' },
    { name: 'Varela Round',       family: "'Varela Round', sans-serif",      weight: '400', cat: 'Sans Serif' },
    { name: 'Poppins',            family: "'Poppins', sans-serif",           weight: '700', cat: 'Sans Serif' },
    { name: 'Nunito',             family: "'Nunito', sans-serif",            weight: '700', cat: 'Sans Serif' },
    { name: 'Quicksand',          family: "'Quicksand', sans-serif",         weight: '700', cat: 'Sans Serif' },
    { name: 'Lato',               family: "'Lato', sans-serif",              weight: '700', cat: 'Sans Serif' },
    { name: 'Open Sans',          family: "'Open Sans', sans-serif",         weight: '700', cat: 'Sans Serif' },
    { name: 'Rubik',              family: "'Rubik', sans-serif",             weight: '700', cat: 'Sans Serif' },
    { name: 'Work Sans',          family: "'Work Sans', sans-serif",         weight: '700', cat: 'Sans Serif' },
    { name: 'Barlow',             family: "'Barlow', sans-serif",            weight: '700', cat: 'Sans Serif' },
    { name: 'DM Sans',            family: "'DM Sans', sans-serif",           weight: '700', cat: 'Sans Serif' },
    { name: 'Karla',              family: "'Karla', sans-serif",             weight: '700', cat: 'Sans Serif' },
    { name: 'Mulish',             family: "'Mulish', sans-serif",            weight: '700', cat: 'Sans Serif' },
    { name: 'Cabin',              family: "'Cabin', sans-serif",             weight: '700', cat: 'Sans Serif' },
    { name: 'Jost',               family: "'Jost', sans-serif",              weight: '700', cat: 'Sans Serif' },
    { name: 'Outfit',             family: "'Outfit', sans-serif",            weight: '700', cat: 'Sans Serif' },
    { name: 'Manrope',            family: "'Manrope', sans-serif",           weight: '700', cat: 'Sans Serif' },
    { name: 'Playfair Display',   family: "'Playfair Display', serif",       weight: '700', cat: 'Serif' },
    { name: 'Cinzel',             family: "'Cinzel', serif",                 weight: '700', cat: 'Serif' },
    { name: 'Merriweather',       family: "'Merriweather', serif",           weight: '700', cat: 'Serif' },
    { name: 'Lora',               family: "'Lora', serif",                   weight: '700', cat: 'Serif' },
    { name: 'Arvo',               family: "'Arvo', serif",                   weight: '700', cat: 'Serif' },
    { name: 'Libre Baskerville',  family: "'Libre Baskerville', serif",      weight: '700', cat: 'Serif' },
    { name: 'Cormorant Garamond', family: "'Cormorant Garamond', serif",     weight: '700', cat: 'Serif' },
    { name: 'EB Garamond',        family: "'EB Garamond', serif",            weight: '700', cat: 'Serif' },
    { name: 'Cardo',              family: "'Cardo', serif",                  weight: '400', cat: 'Serif' },
    { name: 'Josefin Slab',       family: "'Josefin Slab', serif",           weight: '700', cat: 'Serif' },
    { name: 'Lobster',            family: "'Lobster', cursive",              weight: '400', cat: 'Script' },
    { name: 'Pacifico',           family: "'Pacifico', cursive",             weight: '400', cat: 'Script' },
    { name: 'Dancing Script',     family: "'Dancing Script', cursive",       weight: '700', cat: 'Script' },
    { name: 'Great Vibes',        family: "'Great Vibes', cursive",          weight: '400', cat: 'Script' },
    { name: 'Satisfy',            family: "'Satisfy', cursive",              weight: '400', cat: 'Script' },
    { name: 'Sacramento',         family: "'Sacramento', cursive",           weight: '400', cat: 'Script' },
    { name: 'Allura',             family: "'Allura', cursive",               weight: '400', cat: 'Script' },
    { name: 'Alex Brush',         family: "'Alex Brush', cursive",           weight: '400', cat: 'Script' },
    { name: 'Tangerine',          family: "'Tangerine', cursive",            weight: '700', cat: 'Script' },
    { name: 'Kaushan Script',     family: "'Kaushan Script', cursive",       weight: '400', cat: 'Script' },
    { name: 'Courgette',          family: "'Courgette', cursive",            weight: '400', cat: 'Script' },
    { name: 'Caveat',             family: "'Caveat', cursive",               weight: '700', cat: 'Script' },
    { name: 'Amatic SC',          family: "'Amatic SC', cursive",            weight: '700', cat: 'Script' },
    { name: 'Cookie',             family: "'Cookie', cursive",               weight: '400', cat: 'Script' },
    { name: 'Yellowtail',         family: "'Yellowtail', cursive",           weight: '400', cat: 'Script' },
    { name: 'Pinyon Script',      family: "'Pinyon Script', cursive",        weight: '400', cat: 'Script' }
  ];

  // ── Garment State ─────────────────────────────────────────

  function defaultGarment() {
    return { orderMode: null, existingProduct: null,
      type: null, color: null, designType: null, designText: '',
      textColor: null, outline: false, outlineColor: null, font: null,
      printSide: null, frontPlacement: null, backPlacement: null,
      quantity: 1, matchingSet: false, inspoDescription: '' };
  }

  var garments = [defaultGarment()];

  // ── Product list cache (for "modify existing" flow) ───────
  var _cachedProducts = null;
  var _productsFetchPromise = null;

  function fetchProducts() {
    if (_cachedProducts) return Promise.resolve(_cachedProducts);
    if (_productsFetchPromise) return _productsFetchPromise;

    // Fetch from both Sorority and Fraternity collections, deduplicate by id
    var urls = [
      '/collections/all-greek-apparel/products.json?limit=250',
      '/collections/all-fraternity-apparel/products.json?limit=250'
    ];
    _productsFetchPromise = Promise.all(urls.map(function (u) {
      return fetch(u).then(function (r) { return r.json(); }).catch(function () { return { products: [] }; });
    })).then(function (results) {
      var seen = {};
      var all = [];
      results.forEach(function (data) {
        (data.products || []).forEach(function (p) {
          if (!seen[p.id]) {
            seen[p.id] = true;
            var img = p.images && p.images[0] ? p.images[0].src : null;
            if (img) img = img.replace(/(\.[a-z]+)(\?|$)/, '_160x160_crop_center$1$2');
            all.push({ id: p.id, title: p.title, handle: p.handle, product_type: p.product_type, image: img });
          }
        });
      });
      _cachedProducts = all;
      return _cachedProducts;
    });
    return _productsFetchPromise;
  }

  // Kick off a background fetch so the list is ready by the time someone needs it
  fetchProducts();

  function buildProductPicker(g, idx) {
    var wrap = document.createElement('div');
    wrap.className = 'gt-product-picker';

    // Selected product image preview (shown once product is picked)
    var previewWrap = document.createElement('div');
    previewWrap.className = 'gt-garment-preview';
    previewWrap.style.display = g.existingProduct && g.existingProduct.image ? '' : 'none';
    if (g.existingProduct && g.existingProduct.image) {
      var prevImg = document.createElement('img');
      prevImg.src = g.existingProduct.image;
      prevImg.alt = g.existingProduct.title;
      prevImg.className = 'gt-garment-preview__img';
      previewWrap.appendChild(prevImg);
    }
    wrap.appendChild(previewWrap);

    var input = document.createElement('input');
    input.className = 'gt-input';
    input.type = 'text';
    input.placeholder = 'Search our designs…';
    input.autocomplete = 'off';
    input.dataset.fieldId = 'product-search-' + idx;
    if (g.existingProduct) input.value = g.existingProduct.title;

    var list = document.createElement('ul');
    list.className = 'gt-product-picker__list';
    list.style.display = 'none';

    function renderProductList(query) {
      list.innerHTML = '';
      fetchProducts().then(function (products) {
        var q = (query || '').toLowerCase();
        var filtered = products.filter(function (p) {
          return !q || p.title.toLowerCase().indexOf(q) !== -1;
        }).slice(0, 20);
        if (!filtered.length) {
          var empty = document.createElement('li');
          empty.className = 'gt-product-picker__item gt-product-picker__item--empty';
          empty.textContent = 'No designs found';
          list.appendChild(empty);
        } else {
          filtered.forEach(function (p) {
            var li = document.createElement('li');
            li.className = 'gt-product-picker__item' + (g.existingProduct && g.existingProduct.id === p.id ? ' is-active' : '');
            if (p.image) {
              var thumb = document.createElement('img');
              thumb.src = p.image;
              thumb.alt = '';
              thumb.className = 'gt-product-picker__thumb';
              li.appendChild(thumb);
            }
            var titleSpan = document.createElement('span');
            titleSpan.textContent = p.title;
            li.appendChild(titleSpan);
            li.addEventListener('mousedown', function (e) {
              e.preventDefault();
              garments[idx].existingProduct = p;
              input.value = p.title;
              list.style.display = 'none';
              renderAllGarments();
            });
            list.appendChild(li);
          });
        }
        list.style.display = '';
      });
    }

    input.addEventListener('focus', function () { renderProductList(input.value); });
    input.addEventListener('input', function () {
      garments[idx].existingProduct = null;
      renderProductList(input.value);
    });
    input.addEventListener('blur', function () {
      setTimeout(function () { list.style.display = 'none'; }, 200);
    });

    wrap.appendChild(input);
    wrap.appendChild(list);
    return wrap;
  }
  var garmentsContainer = document.getElementById('gt-garments-container');
  var addGarmentBtn = document.getElementById('gt-add-garment-btn');

  // ── DOM helpers ───────────────────────────────────────────

  function buildLabel(text, required) {
    var el = document.createElement('p');
    el.className = 'gt-cfg-label';
    el.textContent = text;
    if (required) {
      var star = document.createElement('span');
      star.className = 'gt-required';
      star.setAttribute('aria-hidden', 'true');
      star.textContent = ' *';
      el.appendChild(star);
    }
    return el;
  }

  function buildPillGroup(options, selected, onChangeFn) {
    var wrap = document.createElement('div');
    wrap.className = 'gt-pill-group';
    options.forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gt-pill' + (selected === opt.id ? ' is-active' : '');
      btn.textContent = opt.label;
      if (opt.hint) btn.title = opt.hint;
      btn.addEventListener('click', function () {
        wrap.querySelectorAll('.gt-pill').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        onChangeFn(opt.id);
      });
      wrap.appendChild(btn);
    });
    return wrap;
  }

  // Build a color swatch grid. withCustomPicker = true adds the "+" label for text colors only.
  function buildColorGrid(colors, selected, onChangeFn, withCustomPicker) {
    var wrap = document.createElement('div');
    wrap.className = 'gt-color-grid';

    colors.forEach(function (c) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gt-color-swatch' + (selected && selected.name === c.name ? ' is-active' : '');
      btn.title = c.name;
      btn.setAttribute('aria-label', c.name);
      btn.dataset.colorName = c.name;
      btn.style.backgroundColor = c.hex;
      if (c.name === 'White' || c.hex === '#FFFFFF' || c.hex === '#F5F5F5') {
        btn.style.boxShadow = 'inset 0 0 0 1px #ccc';
      }
      btn.addEventListener('click', function () {
        wrap.querySelectorAll('.gt-color-swatch').forEach(function (b) {
          b.classList.remove('is-active');
          if (b.classList.contains('gt-color-swatch--plus') && selected && selected.custom) {
            b.style.removeProperty('background-color');
          }
        });
        btn.classList.add('is-active');
        updateColorNameTag(wrap, c);
        onChangeFn(c);
      });
      wrap.appendChild(btn);
    });

    // Custom "+" color picker — only for text/outline colors, mobile-friendly via label
    if (withCustomPicker) {
      var label = document.createElement('label');
      label.className = 'gt-color-swatch gt-color-swatch--plus' + (selected && selected.custom ? ' is-active' : '');
      label.title = 'Custom color';
      label.setAttribute('aria-label', 'Pick a custom color');
      if (selected && selected.custom) {
        label.style.backgroundColor = selected.hex;
        label.style.border = '2px solid #950605';
      }
      label.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      var picker = document.createElement('input');
      picker.type = 'color';
      picker.className = 'gt-color-picker-input';
      picker.value = (selected && selected.custom) ? selected.hex : '#cccccc';
      picker.addEventListener('input', function () {
        var c = { name: 'Custom', hex: picker.value, custom: true };
        wrap.querySelectorAll('.gt-color-swatch').forEach(function (b) { b.classList.remove('is-active'); });
        label.classList.add('is-active');
        label.style.backgroundColor = picker.value;
        label.style.border = '2px solid #950605';
        updateColorNameTag(wrap, c);
        onChangeFn(c);
      });
      label.appendChild(picker);
      wrap.appendChild(label);
    }

    // Color name tag
    if (selected) {
      wrap.appendChild(makeColorNameTag(selected));
    }

    return wrap;
  }

  function makeColorNameTag(c) {
    var tag = document.createElement('div');
    tag.className = 'gt-color-name-tag';
    var dot = document.createElement('span');
    dot.className = 'gt-color-name-tag__dot';
    dot.style.backgroundColor = c.hex;
    if (c.name === 'White' || c.hex === '#FFFFFF' || c.hex === '#F5F5F5') dot.style.boxShadow = 'inset 0 0 0 1px #ccc';
    tag.appendChild(dot);
    tag.appendChild(document.createTextNode(c.name === 'Custom' ? 'Custom (' + c.hex + ')' : c.name));
    return tag;
  }

  function updateColorNameTag(gridEl, c) {
    var existing = gridEl.querySelector('.gt-color-name-tag');
    var newTag = makeColorNameTag(c);
    if (existing) gridEl.replaceChild(newTag, existing);
    else gridEl.appendChild(newTag);
  }

  function buildToggleRow(label, checked, onChange) {
    var row = document.createElement('label');
    row.className = 'gt-toggle-row';
    var input = document.createElement('input');
    input.type = 'checkbox';
    input.className = 'gt-toggle-check';
    input.checked = checked;
    input.addEventListener('change', function () { onChange(input.checked); });
    var track = document.createElement('span');
    track.className = 'gt-toggle-track';
    var text = document.createElement('span');
    text.className = 'gt-toggle-text';
    text.textContent = label;
    row.appendChild(input);
    row.appendChild(track);
    row.appendChild(text);
    return row;
  }

  // ── Lazy Google Fonts loader ──────────────────────────────
  var _fontsLoaded = false;
  function ensureFontsLoaded() {
    if (_fontsLoaded) return;
    _fontsLoaded = true;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Alex+Brush&family=Allura&family=Amatic+SC:wght@700&family=Anton&family=Archivo+Black&family=Arvo:wght@700&family=Bangers&family=Barlow:wght@700&family=Bebas+Neue&family=Black+Han+Sans&family=Boogaloo&family=Cabin:wght@700&family=Cardo&family=Caveat:wght@700&family=Cinzel:wght@700&family=Cookie&family=Cormorant+Garamond:wght@700&family=Courgette&family=Dancing+Script:wght@700&family=DM+Sans:wght@700&family=EB+Garamond:wght@700&family=Fjalla+One&family=Fredoka+One&family=Great+Vibes&family=Jost:wght@700&family=Josefin+Sans:wght@700&family=Josefin+Slab:wght@700&family=Karla:wght@700&family=Kaushan+Script&family=Lato:wght@700&family=Libre+Baskerville:wght@700&family=Lilita+One&family=Lobster&family=Lora:wght@700&family=Manrope:wght@700&family=Merriweather:wght@700&family=Montserrat:wght@700&family=Mulish:wght@700&family=Nunito:wght@700&family=Open+Sans:wght@700&family=Oswald:wght@600&family=Outfit:wght@700&family=Pacifico&family=Passion+One:wght@900&family=Permanent+Marker&family=Pinyon+Script&family=Playfair+Display:wght@700&family=Poppins:wght@700&family=Quicksand:wght@700&family=Raleway:wght@700&family=Righteous&family=Rubik:wght@700&family=Russo+One&family=Sacramento&family=Satisfy&family=Squada+One&family=Tangerine:wght@700&family=Teko:wght@600&family=Titan+One&family=Ubuntu:wght@700&family=Ultra&family=Varela+Round&family=Work+Sans:wght@700&family=Yellowtail&display=swap';
    document.head.appendChild(link);
  }

  function buildFontDropdown(selected, onChange) {
    var wrap = document.createElement('div');
    wrap.className = 'gt-font-dropdown';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gt-font-dropdown__btn';
    if (selected) {
      btn.style.fontFamily = selected.family;
      btn.style.fontWeight = selected.weight;
      btn.textContent = selected.name;
    } else {
      btn.textContent = 'Select a font…';
      btn.style.color = 'rgb(var(--color-foreground-rgb) / 0.4)';
    }

    var panel = document.createElement('div');
    panel.className = 'gt-font-dropdown__panel';
    // Panel starts CLOSED — use style.display, not hidden attr (CSS display:flex would override hidden attr)
    panel.style.display = 'none';

    var searchInput = document.createElement('input');
    searchInput.className = 'gt-font-dropdown__search';
    searchInput.type = 'text';
    searchInput.placeholder = 'Search fonts…';

    var catTabs = document.createElement('div');
    catTabs.className = 'gt-font-dropdown__cats';
    var allCats = ['All', 'Display', 'Sans Serif', 'Serif', 'Script'];
    var activeCat = 'All';
    allCats.forEach(function (cat) {
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'gt-font-dropdown__cat-tab' + (cat === 'All' ? ' is-active' : '');
      tab.textContent = cat;
      tab.addEventListener('click', function () {
        activeCat = cat;
        catTabs.querySelectorAll('.gt-font-dropdown__cat-tab').forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        renderList(searchInput.value);
      });
      catTabs.appendChild(tab);
    });

    var listEl = document.createElement('ul');
    listEl.className = 'gt-font-dropdown__list';

    function renderList(query) {
      var q = (query || '').toLowerCase();
      var filtered = FONTS.filter(function (f) {
        return (!q || f.name.toLowerCase().includes(q)) && (activeCat === 'All' || f.cat === activeCat);
      });
      listEl.innerHTML = '';
      filtered.forEach(function (f) {
        var li = document.createElement('li');
        li.className = 'gt-font-dropdown__item' + (selected && selected.name === f.name ? ' is-active' : '');
        var nameEl = document.createElement('span');
        nameEl.className = 'gt-font-dropdown__item-name';
        nameEl.style.fontFamily = f.family;
        nameEl.style.fontWeight = f.weight;
        nameEl.textContent = f.name;
        var catEl = document.createElement('span');
        catEl.className = 'gt-font-dropdown__item-cat';
        catEl.textContent = f.cat;
        li.appendChild(nameEl);
        li.appendChild(catEl);
        li.addEventListener('mousedown', function (e) {
          e.preventDefault();
          selected = f;
          onChange(f);
          panel.style.display = 'none';
          btn.style.fontFamily = f.family;
          btn.style.fontWeight = f.weight;
          btn.style.color = '';
          btn.textContent = f.name;
          listEl.querySelectorAll('.gt-font-dropdown__item').forEach(function (i) { i.classList.remove('is-active'); });
          li.classList.add('is-active');
        });
        listEl.appendChild(li);
      });
      if (!filtered.length) {
        if (q) {
          var customLi = document.createElement('li');
          customLi.className = 'gt-font-dropdown__item gt-font-dropdown__item--custom';
          var customName = document.createElement('span');
          customName.className = 'gt-font-dropdown__item-name';
          customName.textContent = 'Use "' + query + '"';
          var customCat = document.createElement('span');
          customCat.className = 'gt-font-dropdown__item-cat';
          customCat.textContent = 'Custom';
          customLi.appendChild(customName);
          customLi.appendChild(customCat);
          customLi.addEventListener('mousedown', function (e) {
            e.preventDefault();
            var customFont = { name: query, family: query, weight: 'normal', cat: 'Custom' };
            selected = customFont;
            onChange(customFont);
            panel.style.display = 'none';
            btn.style.fontFamily = '';
            btn.style.fontWeight = '';
            btn.style.color = '';
            btn.textContent = query;
          });
          listEl.appendChild(customLi);
        } else {
          var empty = document.createElement('li');
          empty.className = 'gt-font-dropdown__empty';
          empty.textContent = 'No fonts found';
          listEl.appendChild(empty);
        }
      }
    }

    searchInput.addEventListener('input', function () { renderList(searchInput.value); });
    renderList('');

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      ensureFontsLoaded(); // lazy-load Google Fonts on first open
      var isOpen = panel.style.display !== 'none';
      // Close all other open dropdowns
      document.querySelectorAll('.gt-font-dropdown__panel').forEach(function (p) { p.style.display = 'none'; });
      if (isOpen) return;
      panel.style.display = 'flex';
      searchInput.value = '';
      activeCat = 'All';
      catTabs.querySelectorAll('.gt-font-dropdown__cat-tab').forEach(function (t) { t.classList.toggle('is-active', t.textContent === 'All'); });
      renderList('');
      setTimeout(function () {
        searchInput.focus();
        var activeItem = listEl.querySelector('.is-active');
        if (activeItem) activeItem.scrollIntoView({ block: 'nearest' });
      }, 30);
    });

    panel.appendChild(searchInput);
    panel.appendChild(catTabs);
    panel.appendChild(listEl);
    wrap.appendChild(btn);
    wrap.appendChild(panel);
    return wrap;
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.gt-font-dropdown')) {
      document.querySelectorAll('.gt-font-dropdown__panel').forEach(function (p) { p.style.display = 'none'; });
    }
  });

  // ── Build garment card ────────────────────────────────────

  function buildGarmentCard(g, idx) {
    var card = document.createElement('div');
    card.className = 'gt-garment-card';

    // Header
    var hdr = document.createElement('div');
    hdr.className = 'gt-garment-card__hdr';
    var titleEl = document.createElement('span');
    titleEl.className = 'gt-garment-card__title';
    titleEl.textContent = 'Garment ' + (idx + 1);
    hdr.appendChild(titleEl);
    if (garments.length > 1) {
      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'gt-garment-card__remove';
      removeBtn.textContent = 'Remove';
      removeBtn.addEventListener('click', function () { garments.splice(idx, 1); renderAllGarments(); });
      hdr.appendChild(removeBtn);
    }
    card.appendChild(hdr);

    // ── Step 1: Order mode — modify existing or create new ──
    card.appendChild(buildLabel('What would you like to do?', true));
    card.appendChild(buildPillGroup([
      { id: 'existing', label: 'Modify an existing design' },
      { id: 'new',      label: 'Create something new' },
      { id: 'inspo',    label: 'Describe it / inspo only' }
    ], g.orderMode, function (id) {
      garments[idx].orderMode = id;
      garments[idx].type = null;
      garments[idx].color = null;
      garments[idx].existingProduct = null;
      garments[idx].designType = null;
      garments[idx].designText = '';
      garments[idx].textColor = null;
      garments[idx].outline = false;
      garments[idx].outlineColor = null;
      garments[idx].font = null;
      garments[idx].printSide = null;
      garments[idx].frontPlacement = null;
      garments[idx].backPlacement = null;
      garments[idx].inspoDescription = '';
      renderAllGarments();
    }));

    // ── Modify existing flow ──
    if (g.orderMode === 'existing') {
      card.appendChild(buildLabel('Which product do you want to modify?', true));
      card.appendChild(buildProductPicker(g, idx));

      if (g.existingProduct) {
        var optNote = document.createElement('p');
        optNote.className = 'gt-design-hint';
        optNote.textContent = 'All fields below are optional — only fill in what you want changed.';
        card.appendChild(optNote);

        // Design type (optional)
        card.appendChild(buildLabel('Change the design style'));
        card.appendChild(buildPillGroup(DESIGN_TYPES, g.designType, function (id) {
          garments[idx].designType = id;
          if (id === 'greek' && !garments[idx].designText && orgInput && orgInput.value.trim()) {
            garments[idx].designText = orgInput.value.trim();
          } else if (id !== 'custom') {
            garments[idx].designText = '';
          }
          renderAllGarments();
        }));

        if (g.designType) {
          var eTextField = document.createElement('div');
          eTextField.className = 'gt-field gt-field--indent';
          if (g.designType === 'custom') {
            var eTLbl = document.createElement('label');
            eTLbl.className = 'gt-label';
            eTLbl.textContent = 'Your custom text';
            eTextField.appendChild(eTLbl);
            var eTInput = document.createElement('input');
            eTInput.className = 'gt-input';
            eTInput.type = 'text';
            eTInput.value = g.designText;
            eTInput.placeholder = 'Type anything you want printed…';
            eTInput.dataset.fieldId = 'design-text-' + idx;
            eTInput.addEventListener('input', function () { garments[idx].designText = eTInput.value; });
            eTextField.appendChild(eTInput);
          } else {
            var eHint = document.createElement('p');
            eHint.className = 'gt-design-hint';
            var EXAMPLES = { greek: 'e.g. ΑΦ, ΦΣΣ — from your chapter above', shortform: 'e.g. Phi Sig · Alpha Phi', fullform: 'e.g. Phi Sigma Sigma · Alpha Phi' };
            if (g.designType === 'greek' && orgInput && orgInput.value.trim()) { garments[idx].designText = orgInput.value.trim(); }
            eHint.textContent = EXAMPLES[g.designType] || '';
            eTextField.appendChild(eHint);
          }
          card.appendChild(eTextField);
        }

        // Text color (optional)
        card.appendChild(buildLabel('Change text color'));
        card.appendChild(buildColorGrid(TEXT_COLORS, g.textColor, function (c) { garments[idx].textColor = c; }, true));

        // Outline toggle (optional)
        card.appendChild(buildLabel('Text outline'));
        card.appendChild(buildToggleRow('Add an outline to the text', g.outline, function (val) {
          garments[idx].outline = val;
          if (!val) garments[idx].outlineColor = null;
          renderAllGarments();
        }));
        if (g.outline) {
          var eOcWrap = document.createElement('div');
          eOcWrap.className = 'gt-field gt-field--indent';
          eOcWrap.appendChild(buildLabel('Outline color'));
          eOcWrap.appendChild(buildColorGrid(TEXT_COLORS, g.outlineColor, function (c) { garments[idx].outlineColor = c; }, true));
          card.appendChild(eOcWrap);
        }

        // Font (optional)
        card.appendChild(buildLabel('Change font'));
        var eFontHint = document.createElement('p');
        eFontHint.className = 'gt-design-hint';
        eFontHint.textContent = "Don't see your font? Search for it and select \"Use [name]\" — we'll do our best to match it.";
        card.appendChild(eFontHint);
        card.appendChild(buildFontDropdown(g.font, function (f) { garments[idx].font = f; }));

        // Print location (optional)
        card.appendChild(buildLabel('Print location'));
        card.appendChild(buildPillGroup(PRINT_SIDES, g.printSide, function (id) {
          garments[idx].printSide = id;
          garments[idx].frontPlacement = null;
          garments[idx].backPlacement = null;
          renderAllGarments();
        }));

        if (g.printSide === 'front' || g.printSide === 'front-back') {
          card.appendChild(buildLabel('Front placement'));
          card.appendChild(buildPillGroup(FRONT_PLACEMENTS, g.frontPlacement, function (id) { garments[idx].frontPlacement = id; }));
        }
        if (g.printSide === 'back' || g.printSide === 'front-back') {
          card.appendChild(buildLabel('Back placement'));
          card.appendChild(buildPillGroup(BACK_PLACEMENTS, g.backPlacement, function (id) { garments[idx].backPlacement = id; }));
        }

        // Quantity
        card.appendChild(buildLabel('Estimated quantity'));
        var eQWrap = document.createElement('div');
        eQWrap.className = 'gt-field';
        var eQInput = document.createElement('input');
        eQInput.className = 'gt-input gt-input--short';
        eQInput.type = 'number';
        eQInput.min = '1';
        eQInput.value = String(g.quantity || 1);
        eQInput.placeholder = '1';
        eQInput.dataset.fieldId = 'qty-' + idx;
        eQInput.addEventListener('input', function () { garments[idx].quantity = Math.max(1, parseInt(eQInput.value, 10) || 1); });
        eQWrap.appendChild(eQInput);
        card.appendChild(eQWrap);
      }

      return card;
    }

    // ── Inspo / description-only flow ──
    if (g.orderMode === 'inspo') {
      var inspoField = document.createElement('div');
      inspoField.className = 'gt-field';
      var inspoLabel = document.createElement('label');
      inspoLabel.className = 'gt-label gt-label--required';
      inspoLabel.textContent = 'Describe what you want';
      inspoField.appendChild(inspoLabel);
      var inspoTextarea = document.createElement('textarea');
      inspoTextarea.className = 'gt-textarea';
      inspoTextarea.rows = 5;
      inspoTextarea.placeholder = 'Describe the vibe, colors, style, text, garment type… anything helps. The more detail the better!';
      inspoTextarea.value = g.inspoDescription || '';
      inspoTextarea.addEventListener('input', function () { garments[idx].inspoDescription = inspoTextarea.value; });
      inspoField.appendChild(inspoTextarea);
      card.appendChild(inspoField);

      var inspoNote = document.createElement('p');
      inspoNote.className = 'gt-design-hint gt-design-hint--inspo';
      inspoNote.innerHTML = '📸 Add inspo photos using the upload section at the bottom of the form.';
      card.appendChild(inspoNote);

      // Quantity
      card.appendChild(buildLabel('Estimated quantity'));
      var inspoQWrap = document.createElement('div');
      inspoQWrap.className = 'gt-field';
      var inspoQInput = document.createElement('input');
      inspoQInput.className = 'gt-input gt-input--short';
      inspoQInput.type = 'number';
      inspoQInput.min = '1';
      inspoQInput.value = String(g.quantity || 1);
      inspoQInput.placeholder = '1';
      inspoQInput.dataset.fieldId = 'qty-' + idx;
      inspoQInput.addEventListener('input', function () { garments[idx].quantity = Math.max(1, parseInt(inspoQInput.value, 10) || 1); });
      inspoQWrap.appendChild(inspoQInput);
      card.appendChild(inspoQWrap);

      return card;
    }

    // ── Create new flow ──
    if (g.orderMode !== 'new') return card; // nothing more until mode is picked

    // ── Step 2: Choose a blank ──
    card.appendChild(buildLabel('Choose a blank', true));
    card.appendChild(buildPillGroup(GARMENT_TYPES, g.type, function (id) {
      garments[idx].type = id;
      garments[idx].color = null;
      garments[idx].frontPlacement = null;
      garments[idx].backPlacement = null;
      renderAllGarments();
    }));

    // ── Step 3+: Everything below only once a garment type is chosen ──
    if (g.type) {
      // Blank image preview
      var previewUrl = getPreviewUrl(g.type, g.color ? g.color.name : null);
      var prevWrap = document.createElement('div');
      prevWrap.className = 'gt-garment-preview';

      if (previewUrl) {
        var prevImg = document.createElement('img');
        prevImg.src = previewUrl;
        prevImg.alt = g.type + ' blank';
        prevImg.className = 'gt-garment-preview__img';
        prevImg.dataset.previewIdx = idx;
        prevWrap.appendChild(prevImg);
      } else {
        var ph = document.createElement('div');
        ph.className = 'gt-garment-preview__placeholder';
        ph.innerHTML = '<p>' + g.type.charAt(0).toUpperCase() + g.type.slice(1) + '</p><span>Preview coming soon</span>';
        prevWrap.appendChild(ph);
      }
      card.appendChild(prevWrap);

      // Garment color — show all available colors for this garment type
      card.appendChild(buildLabel('Garment color', true));
      var gColorGrid = buildColorGrid(getGarmentColors(g.type), g.color, function (c) {
        garments[idx].color = c;
        var previewImgEl = card.querySelector('[data-preview-idx="' + idx + '"]');
        if (previewImgEl) {
          var url = getPreviewUrl(garments[idx].type, c.name);
          if (url) previewImgEl.src = url;
        }
      }, false);
      card.appendChild(gColorGrid);

      // ── Step 3: Design type ──
      card.appendChild(buildLabel('Design', true));
      card.appendChild(buildPillGroup(DESIGN_TYPES, g.designType, function (id) {
        garments[idx].designType = id;
        // Auto-fill greek text from personal details sorority field
        if (id === 'greek' && !garments[idx].designText && orgInput && orgInput.value.trim()) {
          garments[idx].designText = orgInput.value.trim();
        } else {
          garments[idx].designText = '';
        }
        renderAllGarments();
      }));

      // ── Step 4+: Design details (only after design type chosen) ──
      if (g.designType) {
        // Design text field — input only for custom, hint for the rest
        var textField = document.createElement('div');
        textField.className = 'gt-field gt-field--indent';

        if (g.designType === 'custom') {
          var tLbl = document.createElement('label');
          tLbl.className = 'gt-label';
          tLbl.textContent = 'Your custom text';
          textField.appendChild(tLbl);
          var tInput = document.createElement('input');
          tInput.className = 'gt-input';
          tInput.type = 'text';
          tInput.value = g.designText;
          tInput.placeholder = 'Type anything you want printed…';
          tInput.dataset.fieldId = 'design-text-' + idx;
          tInput.addEventListener('input', function () { garments[idx].designText = tInput.value; });
          textField.appendChild(tInput);
        } else {
          // Greek / Short form / Full form — show example only, no input
          var EXAMPLES = {
            greek:     'e.g. ΑΦ, ΦΣΣ, ΣΧ — we\'ll use your sorority/frat from your details',
            shortform: 'e.g. Phi Sig · Alpha Phi · Sig Chi',
            fullform:  'e.g. Phi Sigma Sigma · Alpha Phi · Sigma Chi'
          };
          // Auto-capture org from personal details for greek
          if (g.designType === 'greek' && orgInput && orgInput.value.trim()) {
            garments[idx].designText = orgInput.value.trim();
          }
          var hint = document.createElement('p');
          hint.className = 'gt-design-hint';
          hint.textContent = EXAMPLES[g.designType] || '';
          textField.appendChild(hint);
        }
        card.appendChild(textField);

        // Text color
        card.appendChild(buildLabel('Text color', true));
        card.appendChild(buildColorGrid(TEXT_COLORS, g.textColor, function (c) {
          garments[idx].textColor = c;
        }, true));

        // Outline toggle
        card.appendChild(buildLabel('Text outline'));
        card.appendChild(buildToggleRow('Add an outline to the text', g.outline, function (val) {
          garments[idx].outline = val;
          if (!val) garments[idx].outlineColor = null;
          renderAllGarments();
        }));

        // Outline color
        if (g.outline) {
          var ocWrap = document.createElement('div');
          ocWrap.className = 'gt-field gt-field--indent';
          ocWrap.appendChild(buildLabel('Outline color'));
          ocWrap.appendChild(buildColorGrid(TEXT_COLORS, g.outlineColor, function (c) {
            garments[idx].outlineColor = c;
          }, true));
          card.appendChild(ocWrap);
        }

        // Font
        card.appendChild(buildLabel('Font', true));
        var fontHint = document.createElement('p');
        fontHint.className = 'gt-design-hint';
        fontHint.textContent = "Don't see your font? Search for it and select \"Use [name]\" — we'll do our best to match it.";
        card.appendChild(fontHint);
        card.appendChild(buildFontDropdown(g.font, function (f) {
          garments[idx].font = f;
        }));

        // Print location
        card.appendChild(buildLabel('Print location', true));
        card.appendChild(buildPillGroup(PRINT_SIDES, g.printSide, function (id) {
          garments[idx].printSide = id;
          garments[idx].frontPlacement = null;
          garments[idx].backPlacement = null;
          renderAllGarments();
        }));

        // Front placement
        if (g.printSide === 'front' || g.printSide === 'front-back') {
          var frontOpts = BOTTOM_GARMENTS[g.type] ? BOTTOM_FRONT_PLACEMENTS : FRONT_PLACEMENTS;
          card.appendChild(buildLabel('Front placement', true));
          card.appendChild(buildPillGroup(frontOpts, g.frontPlacement, function (id) {
            garments[idx].frontPlacement = id;
          }));
        }

        // Back placement
        if (g.printSide === 'back' || g.printSide === 'front-back') {
          var backOpts = BOTTOM_GARMENTS[g.type] ? BOTTOM_BACK_PLACEMENTS : BACK_PLACEMENTS;
          card.appendChild(buildLabel('Back placement', true));
          card.appendChild(buildPillGroup(backOpts, g.backPlacement, function (id) {
            garments[idx].backPlacement = id;
          }));
        }

        // Quantity
        card.appendChild(buildLabel('Estimated quantity'));
        var qWrap = document.createElement('div');
        qWrap.className = 'gt-field';
        var qInput = document.createElement('input');
        qInput.className = 'gt-input gt-input--short';
        qInput.type = 'number';
        qInput.min = '1';
        qInput.value = String(g.quantity || 1);
        qInput.placeholder = '1';
        qInput.dataset.fieldId = 'qty-' + idx;
        qInput.addEventListener('input', function () { garments[idx].quantity = Math.max(1, parseInt(qInput.value, 10) || 1); });
        qWrap.appendChild(qInput);
        card.appendChild(qWrap);

      } // end if (g.designType)
    } // end if (g.type)

    return card;
  }

  // ── Render ────────────────────────────────────────────────

  function renderAllGarments() {
    var focusFieldId = document.activeElement ? document.activeElement.dataset.fieldId : null;
    var cursorPos = null;
    try { cursorPos = document.activeElement ? document.activeElement.selectionStart : null; } catch (e) {}

    garmentsContainer.innerHTML = '';
    garments.forEach(function (g, i) {
      garmentsContainer.appendChild(buildGarmentCard(g, i));
    });

    if (focusFieldId) {
      var el = garmentsContainer.querySelector('[data-field-id="' + focusFieldId + '"]');
      if (el) {
        el.focus();
        if (cursorPos !== null && el.setSelectionRange) {
          try { el.setSelectionRange(cursorPos, cursorPos); } catch (e) {}
        }
      }
    }
  }

  renderAllGarments();

  // ── Auto-fill from URL params ──────────────────────────────────────────
  // ?type=tee|hoodie|shorts|… → pre-select garment type in "create new" mode
  // ?product=HANDLE           → pre-select an existing product in "modify" mode
  (function () {
    var params = new URLSearchParams(window.location.search);

    // ?type= pre-selects garment type (new order flow)
    var typeParam = params.get('type');
    if (typeParam) {
      var validType = GARMENT_TYPES.find(function (t) { return t.id === typeParam; });
      if (validType) {
        garments[0].orderMode = 'new';
        garments[0].type = validType.id;
        renderAllGarments();
      }
    }

    // ?product= pre-selects an existing product (modify flow)
    var productHandle = params.get('product');
    if (productHandle) {
      garments[0].orderMode = 'existing';
      renderAllGarments();
      fetchProducts().then(function (products) {
        var match = products.find(function (p) { return p.handle === productHandle; });
        if (match) {
          garments[0].existingProduct = match;
          renderAllGarments();
        }
      });
    }
  })();

  if (addGarmentBtn) {
    addGarmentBtn.addEventListener('click', function () {
      garments.push(defaultGarment());
      renderAllGarments();
      var cards = garmentsContainer.querySelectorAll('.gt-garment-card');
      var last = cards[cards.length - 1];
      if (last) last.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // ── Photo upload ──────────────────────────────────────────

  var fileInput = document.getElementById('gt-co-file');
  var dropZone  = document.getElementById('gt-co-drop-zone');
  var previews  = document.getElementById('gt-co-previews');
  var dropHint  = document.getElementById('gt-co-drop-hint');
  var MAX_FILES = 5, MAX_BYTES = 5 * 1024 * 1024;
  var ALLOWED = ['image/jpeg','image/png','image/gif'];
  var selectedFiles = [];

  dropZone.addEventListener('dragover', function (e) { e.preventDefault(); dropZone.classList.add('is-dragover'); });
  dropZone.addEventListener('dragleave', function (e) { e.preventDefault(); dropZone.classList.remove('is-dragover'); });
  dropZone.addEventListener('drop', function (e) { e.preventDefault(); dropZone.classList.remove('is-dragover'); var f = e.dataTransfer && e.dataTransfer.files; if (f) handleFiles(Array.from(f)); });
  dropZone.addEventListener('click', function () { fileInput.click(); });
  dropZone.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); } });
  fileInput.addEventListener('change', function () { if (fileInput.files) handleFiles(Array.from(fileInput.files)); fileInput.value = ''; });

  function handleFiles(files) {
    clearMsg(); var added = 0;
    for (var i = 0; i < files.length; i++) {
      var file = files[i];
      if (selectedFiles.length >= MAX_FILES) { showMsg('error', 'You can upload up to ' + MAX_FILES + ' photos.'); break; }
      if (ALLOWED.indexOf(file.type) === -1) { showMsg('error', '"' + file.name + '" is not a JPG, PNG, or GIF.'); continue; }
      if (file.size > MAX_BYTES) { showMsg('error', '"' + file.name + '" exceeds the 5 MB limit.'); continue; }
      selectedFiles.push(file); added++;
    }
    if (added) renderPreviews(); updateDropZone();
  }
  function renderPreviews() {
    previews.innerHTML = '';
    selectedFiles.forEach(function (file, idx) {
      var item = document.createElement('div');
      item.className = 'gt-preview-item';
      var img = document.createElement('img');
      img.className = 'gt-preview-item__img';
      img.alt = file.name;
      var reader = new FileReader();
      reader.onload = function (e) { img.src = e.target.result; };
      reader.readAsDataURL(file);
      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'gt-preview-item__remove';
      removeBtn.setAttribute('aria-label', 'Remove ' + file.name);
      removeBtn.textContent = '×';
      removeBtn.addEventListener('click', function () { selectedFiles.splice(idx, 1); renderPreviews(); updateDropZone(); clearMsg(); });
      item.appendChild(img); item.appendChild(removeBtn); previews.appendChild(item);
    });
  }
  function updateDropZone() {
    var r = MAX_FILES - selectedFiles.length;
    if (r <= 0) { dropZone.style.display = 'none'; }
    else { dropZone.style.display = ''; dropHint.textContent = 'JPG, PNG or GIF · Max 5 MB each · Up to ' + r + ' more photo' + (r === 1 ? '' : 's'); }
  }
  function resizeAndEncode(file, callback) {
    var reader = new FileReader();
    reader.onload = function (e) {
      var img = new Image();
      img.onload = function () {
        var scale = Math.min(1, 1920 / img.width);
        var w = Math.round(img.width * scale), h = Math.round(img.height * scale);
        var canvas = document.createElement('canvas'); canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        var type = file.type === 'image/gif' ? 'image/jpeg' : file.type;
        callback({ image_base64: canvas.toDataURL(type, 0.85).split(',')[1], image_type: type, image_name: file.name });
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }
  function encodeAllFiles(files, callback) {
    var results = [], remaining = files.length;
    if (!remaining) { callback([]); return; }
    files.forEach(function (file, i) { resizeAndEncode(file, function (enc) { results[i] = enc; if (!--remaining) callback(results); }); });
  }

  // ── Messaging ─────────────────────────────────────────────
  function showFieldErr(id, msg) { var el = document.getElementById(id); if (!el) return; el.textContent = msg; el.classList.add('is-visible'); }
  function clearFieldErr(id) { var el = document.getElementById(id); if (!el) return; el.textContent = ''; el.classList.remove('is-visible'); }
  function showMsg(type, msg) { msgEl.textContent = msg; msgEl.className = 'gt-msg gt-msg--' + type; }
  function clearMsg() { msgEl.textContent = ''; msgEl.className = 'gt-msg'; }
  nameInput.addEventListener('input', function () { clearFieldErr('gt-co-name-err'); });
  emailInput.addEventListener('input', function () { clearFieldErr('gt-co-email-err'); });
  if (orgInput) orgInput.addEventListener('input', function () { clearFieldErr('gt-co-org-err'); });

  // ── Submit ────────────────────────────────────────────────
  form.addEventListener('submit', function (e) {
    e.preventDefault(); clearMsg();
    ['gt-co-name-err','gt-co-email-err','gt-co-org-err'].forEach(clearFieldErr);
    var name  = nameInput.value.trim(), email = emailInput.value.trim();
    var org   = orgInput ? orgInput.value.trim() : '';
    var uni   = uniInput ? uniInput.value.trim() : '';
    var notes = notesInput ? notesInput.value.trim() : '';
    var deadline = deadlineInput ? deadlineInput.value : '';
    var valid = true;
    var detailsErrors = [];
    if (!name) { showFieldErr('gt-co-name-err', 'Full name is required.'); detailsErrors.push('full name'); valid = false; }
    if (!email) { showFieldErr('gt-co-email-err', 'Email address is required.'); detailsErrors.push('email'); valid = false; }
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { showFieldErr('gt-co-email-err', 'Please enter a valid email address.'); detailsErrors.push('a valid email'); valid = false; }
    if (!org) { showFieldErr('gt-co-org-err', 'Sorority / Fraternity is required.'); detailsErrors.push('sorority / fraternity'); valid = false; }
    if (detailsErrors.length) { showMsg('error', 'Please fill in your ' + detailsErrors.join(', ') + ' at the top of the form.'); }
    if (!garments.some(function (g) { return g.orderMode; })) { showMsg('error', 'Please select what you\'d like to do for at least one garment.'); valid = false; }
    // Per-garment required field validation
    garments.forEach(function (g, i) {
      var n = garments.length > 1 ? 'Garment ' + (i + 1) + ': ' : '';
      if (!g.orderMode) { showMsg('error', n + 'Please select whether you\'re modifying an existing design or creating something new.'); valid = false; return; }
      if (g.orderMode === 'existing') {
        if (!g.existingProduct) { showMsg('error', n + 'Please choose which product you want to modify.'); valid = false; }
        return; // all other fields optional for existing mode
      }
      if (g.orderMode === 'inspo') {
        if (!g.inspoDescription || !g.inspoDescription.trim()) { showMsg('error', n + 'Please describe what you\'re looking for.'); valid = false; }
        return;
      }
      // 'new' mode — all fields required
      if (!g.type)        { showMsg('error', n + 'Please select a garment type.'); valid = false; return; }
      if (!g.color)       { showMsg('error', n + 'Please select a garment color.'); valid = false; return; }
      if (!g.designType)  { showMsg('error', n + 'Please select a design type.'); valid = false; return; }
      if (g.designType === 'custom' && !g.designText.trim()) { showMsg('error', n + 'Please enter your custom text.'); valid = false; return; }
      if (!g.textColor)   { showMsg('error', n + 'Please select a text color.'); valid = false; return; }
      if (!g.font)        { showMsg('error', n + 'Please select a font.'); valid = false; return; }
      if (!g.printSide)   { showMsg('error', n + 'Please select a print location.'); valid = false; return; }
      if ((g.printSide === 'front' || g.printSide === 'front-back') && !g.frontPlacement) { showMsg('error', n + 'Please select a front placement.'); valid = false; return; }
      if ((g.printSide === 'back'  || g.printSide === 'front-back') && !g.backPlacement)  { showMsg('error', n + 'Please select a back placement.');  valid = false; return; }
    });
    if (!valid) return;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting…';
    var DESIGN_LABELS = { greek: 'Greek Letters', shortform: 'Short Form Text', fullform: 'Full Form Text', custom: 'Custom Text' };
    function colorLabel(c) {
      if (!c) return '';
      return (c.custom || c.name === 'Custom') ? 'Custom (' + c.hex + ')' : c.name;
    }
    var gPayload = garments.map(function (g, i) {
      var obj = {
        garment_number: i+1,
        order_mode: g.orderMode || 'new',
        quantity: g.quantity||1
      };
      if (g.orderMode === 'inspo') {
        obj.inspo_description = g.inspoDescription || '';
      } else if (g.orderMode === 'existing' && g.existingProduct) {
        obj.existing_product = g.existingProduct.title;
        obj.existing_product_handle = g.existingProduct.handle;
      } else {
        obj.type = g.type||'';
        obj.color = g.color ? g.color.name : '';
      }
      if (g.designType) obj.design_type = DESIGN_LABELS[g.designType] || g.designType;
      if (g.designText) obj.design_text = g.designText;
      if (g.textColor)  obj.text_color = colorLabel(g.textColor);
      if (g.outline)    { obj.outline = true; obj.outline_color = colorLabel(g.outlineColor); }
      if (g.font)       obj.font = g.font.name;
      if (g.printSide)  obj.print_side = g.printSide;
      if (g.frontPlacement) obj.front_placement = g.frontPlacement;
      if (g.backPlacement)  obj.back_placement  = g.backPlacement;
      return obj;
    });
    var payload = { name: name, email: email, organization: org, university: uni, garments: gPayload, notes: notes, deadline: deadline };
    if (selectedFiles.length > 0) {
      encodeAllFiles(selectedFiles, function (images) { payload.images = images; submitOrder(payload); });
    } else { submitOrder(payload); }
  });

  function submitOrder(payload) {
    fetch(NETLIFY + '/custom-order-request', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
    })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
      .then(function (result) {
        if (result.ok && result.data && result.data.success) {
          form.hidden = true; if (header) header.hidden = true; successDiv.hidden = false;
        } else {
          showMsg('error', (result.data && result.data.error) || 'Something went wrong. Please try again.');
          resetBtn();
        }
      })
      .catch(function () { showMsg('error', 'Network error. Please check your connection and try again.'); resetBtn(); });
  }
  function resetBtn() { submitBtn.disabled = false; submitBtn.textContent = 'Submit Request →'; }
})();
